import { withStyles } from "@material-ui/core/styles";
import { Fade, Modal } from "@material-ui/core";
import axios from "axios";
import React, { Component } from "react";
import { Redirect } from "react-router";
import { Link } from "react-router-dom";
import CloseIcon from "@material-ui/icons/Close";
import navbarsStyle from "../../assets/jss/material-kit-pro-react/views/componentsSections/navbarsStyle";
import BulkUploadDropdown from "../../components/BulkUploadBtn&DownloadTemplateDropdown/BulkUploadDropdown";
import DownloadTemplateDropdown from "../../components/BulkUploadBtn&DownloadTemplateDropdown/DownloadTemplateDropdown";
import Button from "../../components/Material/CustomButtons/Button";
import { GetGHGEstimationUrl, getUserPermision } from "../../config";
import * as PageKeys from "../../pagekeys";
import * as RoleCodes from "../../rolecodes";
import Spinner from "../../UI/Spinner/Spinner";
import DownloadEmissionFactors from "../../components/DownloadEmissionFactors/DownloadEmissionFactors";
import SelectLocation from "./SelectLocation";
import { BreadCrumb, decodeOpAccessToken, downloadExcelFile } from "../../utility";
import { popupAlert } from "../../UI/Popups/popup";
import { showLockUpPopup } from "../../UI/Popups/lockUpPopUp";

let messageData = "";

const GHGEstimate_Link = GetGHGEstimationUrl();

const Statuses = {
  Failure: "failure",
  Success: "successful",
};
const cancelToken = axios.CancelToken;
let source = cancelToken.source();
class GHGActivity extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      location: "",
      selectedFile: null,
      uploadProgress: 0,
      modalContent: "",
      showAlert: false,
      alertMessage: "",
      shrink: false,
      status: "",
      bulkData: [],
      jwtToken: "",
      organizationId: "",
      uploadedFilePath: "",
      failureErrorPath: "",
      isGenericError: false,
      iframeHeight: 0,
      loader: true,
      activities: [],
      mappings: [],
      orgRole: "BUYER",
      pendingUploadActivityCode: null,
      pendingAIActivityCode: null,
      isProductShareRedirectModalOpen: false,
      locationList: [],
      selectedActivity: null,
    };
    // this.handleFileChange = this.handleFileChange.bind(this);
    // this.handleDrop = this.handleDrop.bind(this);
    // this.handleDragOver = this.handleDragOver.bind(this);
  }

  componentDidMount = async () => {
    try {
      this.setState({ jwtToken: localStorage.opsToken }, () => {
        try {
          const decodedToken = decodeOpAccessToken(this.state.jwtToken);
          if (!decodedToken) return;
          const organizationId =
            decodedToken["https://hasura.io/jwt/claims"]["x-hasura-org-id"];
          this.setState({ organizationId: organizationId });
        } catch (error) {
          // Handle token decoding error
          console.error("Error decoding token: ", error);
        }
      });

      // Event listener for iframe height
      window.addEventListener("message", (event) => {
        event.preventDefault();
        if (!isNaN(event.data)) {
          if (this.state.iframeHeight !== event.data) {
            this.setState({ iframeHeight: event.data + 20 });
          }
        }
      });

      // Custom handle function
      this.newHandle();

      await this.fetchActivitiesForTemplateDownload();
    } catch (error) {
      console.error("Error in componentDidMount: ", error);
    }
  };

  componentDidUpdate(prevProps) {
    const previousActivityCode =
      prevProps.match && prevProps.match.params
        ? prevProps.match.params.activityCode
        : "";
    const currentActivityCode =
      this.props.match && this.props.match.params
        ? this.props.match.params.activityCode
        : "";

    if (previousActivityCode !== currentActivityCode && !this.state.loader) {
      this.setState({ loader: true });
    }
  }

  handleProductShareRedirectModalClose = () => {
    this.setState({ isProductShareRedirectModalOpen: false });
  };

  fetchActivitiesForTemplateDownload = async () => {
    try {
      const decodedToken = decodeOpAccessToken(localStorage.opsToken);
      if (!decodedToken) return;

      const opConfig = {
        headers: {
          "x-sk-op-authorization": localStorage.opsToken,
          "Content-Type": "application/json",
        },
      };

      const organizationId =
        decodedToken["https://hasura.io/jwt/claims"]["x-hasura-org-id"];

      const buyerSupplierRoleResponse = await axios.post(
        GetGHGEstimationUrl() + "api/v1/users/buyer-supplier-role",
        { organizationId: organizationId },
        opConfig
      );

      const formData = {
        organizationId: organizationId,
        userId:
          decodedToken["https://hasura.io/jwt/claims"]["x-hasura-user-id"],
        isPCFActivity: true,
      };

      const response = await axios.post(
        GetGHGEstimationUrl() + "api/v1/users/activity-permissions",
        formData,
        opConfig
      );

      const activities = response.data.data
        .filter((item) => item.locations && item.locations.length > 0)
        .map((item) => ({
          activity: item.label,
          activityHeader: item.label,
          activity_code: item.sub_activity,
          section: item.main_activity,
          downloadLink: item.template_link,
          locations: item.locations,
          isLocked:
            item.label === "Product Share Allocation2"
              ? response.data.PCF !== true
              : false,
        }));

      const allActivitiesData = response.data.allActivities
        .filter(
          (item) =>
            !(
              item.code === "buyer_share" &&
              buyerSupplierRoleResponse &&
              buyerSupplierRoleResponse.data &&
              buyerSupplierRoleResponse.data.data === "BUYER"
            )
        )
        .map((item) => {
          const isExist = activities.filter(
            (act) => act.activity_code === item.code
          );
          if (isExist && isExist.length > 0) {
            return {
              ...item,
              ...isExist[0],
            };
          }
          return {
            ...item,
            ...{ activity: item.name },
            ...{ activityHeader: item.name },
            isLocked: true,
          };
        });

      // Keep ordering behavior aligned with DownloadTemplateDropdown.
      allActivitiesData.sort((a, b) => {
        if (a.isLocked !== b.isLocked) {
          return a.isLocked ? 1 : -1;
        }
        const nameA = a.name || a.activity || "";
        const nameB = b.name || b.activity || "";
        return nameA.localeCompare(nameB);
      });

      allActivitiesData.sort((a, b) => {
        if (a.isLocked && b.isLocked) {
          return a.name.localeCompare(b.name);
        }
        return 0;
      });

      this.setState({ activities: allActivitiesData });
    } catch (error) {
      console.error("Error fetching activity permissions:", error);
    }
  };

  openProductShareTemplateModal = () => {
    const activityItem = (this.state.activities || []).find(
      (act) =>
        act.activity_code &&
        act.activity_code.toLowerCase() === "product_share_allocation"
    );

    if (activityItem && activityItem.isLocked) {
      showLockUpPopup({
        type: "download",
        activity: activityItem.activity || activityItem.label || "Template Download",
      });
      return;
    }

    if (!activityItem || !activityItem.locations || activityItem.locations.length === 0) {
      popupAlert(
        "error",
        "Unable to continue",
        "No location found for Product Share Allocation template download."
      );
      return;
    }

    if (activityItem.locations.length === 1) {
      const location = activityItem.locations[0].value;
      this.generateProductShareAllocationTemplate(
        "product_share_allocation",
        activityItem.downloadLink,
        location
      );
      return;
    }

    const menuItems = [...activityItem.locations].sort((a, b) =>
      a.label.localeCompare(b.label)
    );

    const openEvent = new CustomEvent("dropdownStateChange", {
      detail: { isOpen: true, dropdownId: "bulk-upload-dropdown" },
    });
    document.dispatchEvent(openEvent);

    this.setState({
      isProductShareRedirectModalOpen: true,
      modalContent: activityItem.activity,
      uploadedFilePath: activityItem.downloadLink,
      selectedActivity: activityItem.activity,
      locationList: menuItems,
      location: menuItems[0] ? menuItems[0].value : "",
      isGenericError: false,
    });
  };

  generateProductShareAllocationTemplate = async (activity, downloadLink, location) => {
    const decodedToken = decodeOpAccessToken(localStorage.opsToken);
    if (!decodedToken) return;

    try {
      const formData = {
        organizationId:
          decodedToken["https://hasura.io/jwt/claims"]["x-hasura-org-id"],
        organizationAddressId: location || this.state.location,
        filePath: downloadLink || this.state.uploadedFilePath,
      };

      const opConfig = {
        headers: {
          "x-sk-op-authorization": localStorage.opsToken,
          "Content-Type": "application/json",
        },
      };

      const response = await axios.post(
        GetGHGEstimationUrl() +
          "api/v1/ghg-data-import/transaction/product-share-allocation/template",
        formData,
        opConfig
      );

      if (response && response.data && response.data.data && response.data.data.fileData) {
        downloadExcelFile(response.data.data.fileData, response.data.data.fileName);
      }
    } catch (error) {
      popupAlert(
        "error",
        "Download failed",
        "Unable to download Product Share Allocation template right now."
      );
    }
  };

  handleProductShareLocationChange = (event) => {
    const newLocation = String(event.target.value).toLowerCase();

    this.setState({
      location: newLocation,
      uploadProgress: 0,
      showAlert: false,
      alertMessage: "",
      isGenericError: false,
    });
  };

  handleProductShareTemplateModalClose = () => {
    this.setState({
      isProductShareRedirectModalOpen: false,
      location: "",
      isGenericError: false,
    });

    const closeEvent = new CustomEvent("dropdownStateChange", {
      detail: { isOpen: false, dropdownId: "bulk-upload-dropdown" },
    });
    document.dispatchEvent(closeEvent);
  };

  newHandle = () => {
    window.addEventListener("message", (event) => {
      event.preventDefault();
      let dataType = typeof event.data;
      if (dataType === "string") {
        try {
          messageData = "";
          messageData = event.data ? JSON.parse(event.data) : {};
          const { fileName } = messageData;
          const type = messageData.type;
          switch (type) {
            case "op-redirect-to-activity-data-records":
              this.props.history.push("/monthly-activity-data");
              break;
            case "op-redirect-to-data-upload-logs":
              this.props.history.push("/data-upload-logs");
              break;
            case "op-redirect-to-verify-extracted-data":
              const fileId = messageData.data.fileId;
              this.props.history.push({
                pathname: "/verify-extracted-data",
                search: `?fileId=${fileId}`,
                state: { fileId: fileId, isEdit: messageData.data.isEdit },
              });
              break;
            case "open-excel-bulk-upload":
              console.log('[GHGActivity] open-excel-bulk-upload received. messageData:', messageData);
              this.setState(
                {
                  pendingUploadActivityCode:
                    messageData.data && messageData.data.activityCode
                      ? messageData.data.activityCode
                      : null,
                },
                () => console.log('[GHGActivity] state after open-excel-bulk-upload:', this.state.pendingUploadActivityCode)
              );
              break;
            case "open-ai-upload":
              console.log('[GHGActivity] open-ai-upload received. messageData:', messageData);
              this.setState(
                {
                  pendingAIActivityCode:
                    messageData.data && messageData.data.activityCode
                      ? messageData.data.activityCode
                      : null,
                },
                () => console.log('[GHGActivity] state after open-ai-upload:', this.state.pendingAIActivityCode)
              );
              break;
            case "DeleteUploadHistoryRow":
              popupAlert(
                "DeleteConfirmPopup",
                `Delete “${fileName}”?`,
                "The file will be permanently removed.",
                () => {
                  let sendRemoveData = document.getElementById("listIframe1");
                  sendRemoveData.contentWindow.postMessage(
                    JSON.stringify({
                      type: "confirm-file-delete",
                      fileId: messageData.fileId,
                    }),
                    "*"
                  );
                },
                "No, Keep File",
                "Yes, Delete",
                () => {
                  this.setState({
                    showAlert: false,
                    alertMessage: "",
                    status: Statuses.Failure,
                  });
                }
              );
              break;
            case "manual-entry-confirm-cancel":
              popupAlert(
                "confirmPopup",
                "Confirm Cancel",
                "Discard unsaved changes?",
                () => {
                  let iframe = document.getElementById("listIframe1");
                  iframe.contentWindow.postMessage(
                    JSON.stringify({
                      type: "manual-entry-confirm-cancel-response",
                      data: { confirmedDiscard: false },
                    }),
                    "*"
                  );
                },
                "Yes, Discard",
                "No, Keep Editing",
                () => {
                  let iframe = document.getElementById("listIframe1");
                  iframe.contentWindow.postMessage(
                    JSON.stringify({
                      type: "manual-entry-confirm-cancel-response",
                      data: { confirmedDiscard: true },
                    }),
                    "*"
                  );
                }
              );
              break;
            // The data-upload-logs page embeds the same manual-entry listings
            // (Energy Grid, Fuel, Captive Power, Waste) that the dedicated
            // manual-entry containers do, so it needs to handle the same
            // form-updated success messages — otherwise no popup fires after
            // a save/delete on this route.
            case "energy-grid-power-form-updated":
            case "energy-fuel-purchased-form-updated":
            case "energy-captive-power-form-updated":
            case "waste-data-form-updated":
              popupAlert(
                "success",
                "Success",
                messageData.data && messageData.data.isDeleted
                  ? "Data Deleted Successfully"
                  : "Data Saved Successfully"
              );
              break;
            case "confirm-delete-form-entry":
              const deleteOrganizationAddressId = messageData.data.organizationAddressId;
              const deleteSelectedRowIds = messageData.data.selectedRowIdsToDelete;
              popupAlert(
                "deleteConfirmWarpPopupRedButton",
                "Delete Entry",
                "Are you sure want to delete this entry? Once deleted you won't be able to recover this data.",
                () => {
                  let iframe = document.getElementById("listIframe1");
                  iframe.contentWindow.postMessage(
                    JSON.stringify({
                      type: "confirm-delete-form-entry-true",
                      data: {
                        organizationAddressId: deleteOrganizationAddressId,
                        selectedRowIdsToDelete: deleteSelectedRowIds,
                      },
                    }),
                    "*"
                  );
                },
                "NO, KEEP IT",
                "YES, DELETE!"
              );
              break;            
            case "op-redirect-to-productshare-template-download":
              this.openProductShareTemplateModal();
              break;
           
              default:
              break;
          }
        } catch (error) {
          console.error(`Error in ${messageData.type}: `, error);
        }
      }
    });
  };

  getSelectedActivityCode = () => {
    const activityCode =
      this.props.match && this.props.match.params
        ? this.props.match.params.activityCode
        : "";

    if (!activityCode) {
      return "";
    }

    try {
      return decodeURIComponent(activityCode);
    } catch (error) {
      return activityCode;
    }
  };

  iframeUrl = () => {
    const activityCode = this.getSelectedActivityCode();
    const queryString = activityCode
      ? `?activityCode=${encodeURIComponent(activityCode)}`
      : "";

    return (
      GHGEstimate_Link +
      localStorage.opsUserCompanyId +
      "/embed/v1/" +
      this.state.jwtToken +
      "/data-import/excel/history" +
      queryString
    );
  };

  // generateListItems = (buttonText, action) => {
  //     return this.state.bulkData.length !== 0 ? <CustomDropdown
  //         customId={buttonText.replace(/ /g, "_")}
  //         caret={false}
  //         noLiPadding
  //         hoverColor="dark"
  //         dropPlacement={"bottom-end"}
  //         buttonText={
  //             <Button
  //                 className={"secondarydBtn"}
  //                 type="button"
  //                 style={{
  //                     margin: 0,
  //                 }}
  //             >
  //                 {buttonText}
  //             </Button>
  //         }
  //         buttonProps={{
  //             color: "transparent",
  //         }}
  //         dropdownList={this.generateDropdownItems(action)}
  //     /> : <></>
  // };
  // generateDropdownItems = (action) => {
  //     return this.state.bulkData.map((item, index) => (
  //         <React.Fragment key={index}>
  //             <a
  //                 href="#"
  //                 className={this.props.classes.dropdownLink}
  //                 onClick={(e) => {
  //                     e.preventDefault();
  //                     if (action === "upload") {
  //                         this.handleOpen(item.activity, item.downloadLink);
  //                     } else {
  //                         item.activity.toLowerCase() === 'business travel' && window.open(item.downloadLink, "_blank");
  //                         item.activity.toLowerCase() === 'employee travel' && window.open(item.downloadLink, "_blank");
  //                         item.activity.toLowerCase() === 'captive power' && window.open(item.downloadLink, "_blank");
  //                         item.activity.toLowerCase() === 'fuel purchased' && window.open(item.downloadLink, "_blank");
  //                         item.activity.toLowerCase() === 'general details' && window.open(item.downloadLink, "_blank");
  //                         item.activity.toLowerCase() === 'grid power' && window.open(item.downloadLink, "_blank");
  //                         item.activity.toLowerCase() === 'waste' && window.open(item.downloadLink, "_blank");
  //                         item.activity.toLowerCase() === 'upstream transport' && window.open(item.downloadLink, "_blank");
  //                         item.activity.toLowerCase() === 'downstream transport' && window.open(item.downloadLink, "_blank");
  //                         item.activity.toLowerCase() === 'production' && window.open(item.downloadLink, "_blank");
  //                     }
  //                 }}
  //                 style={{
  //                     width: "200px",
  //                 }}
  //             >
  //                 {item.activityHeader}
  //             </a>
  //             {index !== this.state.bulkData.length - 1 && (
  //                 <Divider
  //                     style={{
  //                         backgroundColor: "#e3e3e3",
  //                         marginLeft: "13px",
  //                         height: 1.5,
  //                     }}
  //                     variant="middle"
  //                 />
  //             )}
  //         </React.Fragment>
  //     ));
  // }

  render() {
    const { classes } = this.props;
    const {
      open,
      selectedFile,
      uploadProgress,
      modalContent,
      showAlert,
      alertMessage,
      status,
      isProductShareRedirectModalOpen,
    } = this.state;

    let progressText;
    let progressTextColor;
    let progressBarColor;
    switch (true) {
      case uploadProgress === 100 && status === Statuses.Success:
        progressText = "File Uploaded Succesfully";
        progressTextColor = "#00B41D";
        progressBarColor = "#00B41D";
        break;
      case uploadProgress === 100 && status === Statuses.Failure:
        if (this.state.isGenericError) {
          progressTextColor = "#FA0B0B";
          progressBarColor = "#FA0B0B";
          progressText =
            "Something went wrong on our end. Please try again later.";
        } else {
          progressText = "Errors encountered while uploading the file.";
          progressTextColor = "#FA0B0B";
          progressBarColor = "#FA0B0B";
        }
        break;
      case uploadProgress < 100 && status !== Statuses.Success:
        progressTextColor = "#666666";
        progressBarColor = "#FFA93C";
        progressText = "Please wait file is uploading...";
        break;
      default:
        progressBarColor = "#FFA93C";
        progressTextColor = "#666666";
        progressText = "";
    }

    const isDisabled = uploadProgress > 0 && uploadProgress < 100;

    const permissions =
      localStorage.permissions !== undefined
        ? JSON.parse(localStorage.permissions)
        : [];
    if (permissions && permissions.length === 0) {
      return <Redirect to="/not-found" />;
    } else if (getUserPermision(permissions, PageKeys.GHGActivity) === null) {
      return <Redirect to="/not-found" />;
    }
    let breadCrumb = BreadCrumb([
      { pageName: "Home", url: "/Home" },
      { pageName: "Data Update Logs", url: "/#" },
    ]);


    return (
      <React.Fragment>
        <div className="breadtitle_wrap">
          {breadCrumb}
          <div className="page_top_title">
            <div
              className="page_heading"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-end",
                width: "100%",
              }}
            >
              <h4>Data Update Logs</h4>
              <div
                className="breadCrumbActionButtons"
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 15,
                  position: "relative",
                  top: "-10px",
                }}
              >
                <Button
                  className={"secondarydBtn"}
                  type="button"
                  style={{
                    margin: 0,
                  }}
                >
                  <Link to="monthly-activity-data">Monthly Activity Data</Link>
                </Button>

                {JSON.parse(localStorage.userType) !==
                RoleCodes.ORGANIZATIONADMIN ? (
                  <DownloadTemplateDropdown isIcon={false} />
                ) : (
                  ""
                )}
                { JSON.parse(localStorage.userType) === RoleCodes.ORGANIZATIONADMIN ?
                   <DownloadEmissionFactors /> : null
                }
                <span
                  style={
                    JSON.parse(localStorage.userType) ===
                    RoleCodes.ORGANIZATIONADMIN
                      ? { display: "none" }
                      : {}
                  }
                >
                  <BulkUploadDropdown
                    isIcon={false}
                    uploadActivityCode={this.state.pendingUploadActivityCode}
                    uploadAIActivityCode={this.state.pendingAIActivityCode}
                    onActivityCodeConsumed={() =>
                      this.setState({
                        pendingUploadActivityCode: null,
                        pendingAIActivityCode: null,
                      })
                    }
                  />
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="">
          {this.state.loader && (
            <div style={{ position: "absolute", width: "90%" }}>
              <Spinner />
            </div>
          )}
          <iframe
            allow
            title=" "
            id="listIframe1"
            src={this.iframeUrl()}
            allowFullScreen
            frameBorder="0"
            style={{
              width: "100%",
              height: [0, 20, "0", "20"].includes(this.state.iframeHeight)
                ? "100vh"
                : `${this.state.iframeHeight}px`,
            }}
            loading="eager"
            onLoad={() => this.setState({ loader: false })}
          />
          <Modal
            open={isProductShareRedirectModalOpen}
            onClose={this.handleProductShareTemplateModalClose}
            aria-labelledby="productshare-redirect-title"
            aria-describedby="productshare-redirect-description"
            className="ghgmodal"
          >
            <Fade in={isProductShareRedirectModalOpen}>
              <div className="ghgmodalBox">
                <div className="ghgmodalHeader">
                  <h4 id="productshare-redirect-title">Download Template Data</h4>
                  <CloseIcon onClick={this.handleProductShareTemplateModalClose} />
                </div>
                <div className="ghgmodalBody">
                  <p id="productshare-redirect-description">
                    Please select a facility for which you wish to download the
                    data.
                  </p>
                  <SelectLocation
                    location={this.state.location}
                    handleChange={this.handleProductShareLocationChange}
                    classes={classes}
                    shrink={this.state.shrink}
                    locationList={this.state.locationList}
                  />
                  <Button
                    className="outline_btn_new"
                    onClick={() =>
                      this.generateProductShareAllocationTemplate(
                        this.state.selectedActivity,
                        this.state.uploadedFilePath,
                        this.state.location
                      )
                    }
                  >
                    Download Template
                  </Button>
                </div>
              </div>
            </Fade>
          </Modal>
        </div>
      </React.Fragment>
    );
  }
}
export default withStyles(navbarsStyle)(GHGActivity);
